import {
  SmileOutlined,
  DashboardOutlined,
  EyeInvisibleOutlined,
  HistoryOutlined,
  NotificationOutlined,
  NumberOutlined,
  PlayCircleOutlined,
  SettingOutlined,
  StopOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  ApiOutlined,
  BlockOutlined,
  TransactionOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
// import { Navigate } from "react-router-dom";
import { Layout, Menu } from "antd";
import { storageConstants } from "../../../common/utils";
const { Sider } = Layout;

function getItem(show, label, key, icon, children, type) {
  if (show) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  } else return;
}

const SideMenu = (props) => {
  console.log(props);
  const navigate = useNavigate();

  const handleMenuClick = (event) => {
    const selectedMenuItem = event.domEvent.currentTarget; // Get the selected menu item DOM element
    const selectedMenuLabel = selectedMenuItem.textContent; // Get the label (text) of the selected menu item
    props.updateAuthUser({
      path: event.key,
      currentMenuTitle: selectedMenuLabel,
    });
    navigate(event.key);
  };

  return (
    <Sider trigger={null} collapsible collapsed={props.collapsed}>
      <div className="logo">
        <h3
          style={{
            color: "white",
            textAlign: "center",
          }}
        >
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              gap: "5px",
            }}
          >
            <img
              src={"/assets/images/logo/logo-white.png"}
              height={25}
              backGround="white"
            ></img>{" "}
            {props.collapsed ? "" : storageConstants.PAGES.TITLE.ONENESS}
          </div>
        </h3>
      </div>
      <div className="demo-logo-vertical" />
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[
          (props && props.user && props.user.path) ||
            storageConstants.PAGES.ROUTE.DASHBOARD,
        ]}
        selectedKeys={
          (props && props.user && props.user.path) ||
          storageConstants.PAGES.ROUTE.DASHBOARD
        }
        onClick={handleMenuClick}
        items={[
          getItem(
            true,
            storageConstants.PAGES.MENU.DASHBOARD,
            storageConstants.PAGES.ROUTE.DASHBOARD,
            <DashboardOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.USER_MANAGEMENT,
            storageConstants.PAGES.ROUTE.USER_MANAGEMENT,
            <UsergroupAddOutlined />
            // [
            //   getItem(
            //     true,
            //     storageConstants.PAGES.MENU.USER_MANAGEMENT,
            //     storageConstants.PAGES.ROUTE.USER_MANAGEMENT,
            //     <SolutionOutlined />
            //   ),
            // ]
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.EMOTION_MANAGEMENT,
            storageConstants.PAGES.ROUTE.EMOTION_MANAGEMENT,
            <SmileOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.ACTIVITY_MANAGEMENT,
            storageConstants.PAGES.ROUTE.ACTIVITY_MANAGEMENT,
            <PlayCircleOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.ALARM_MANAGEMENT,
            storageConstants.PAGES.ROUTE.ALARM_MANAGEMENT,
            <HistoryOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.CATEGORIES_MANAGEMENT,
            storageConstants.PAGES.ROUTE.CATEGORIES_MANAGEMENT,
            <EyeInvisibleOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.QUOTE_MANAGEMENT,
            storageConstants.PAGES.ROUTE.QUOTE_MANAGEMENT,
            // <StopOutlined />
            <img src="/assets/images/quote.svg"></img>
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.REMEMBER_ACTIVITY,
            storageConstants.PAGES.ROUTE.REMEMBER_ACTIVITY,
            <BlockOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.MANAGE_CONNECTION,
            storageConstants.PAGES.ROUTE.MANAGE_CONNECTION,
            <ApiOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.SUBSCRIPTION,
            storageConstants.PAGES.ROUTE.SUBSCRIPTION,
            <NotificationOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.TRANSACTIONS,
            storageConstants.PAGES.ROUTE.TRANSACTIONS,
            <TransactionOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.NOTIFICATION,
            storageConstants.PAGES.ROUTE.NOTIFICATIONS,
            <NumberOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.TRAIL_CONFIGURATION,
            storageConstants.PAGES.ROUTE.TRAIL_CONFIGURATION,
            <SettingOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.PROFILE,
            storageConstants.PAGES.ROUTE.PROFILE,
            <UserOutlined />
          ),
          getItem(
            true,
            storageConstants.PAGES.MENU.ACCOUNTS,
            storageConstants.PAGES.ROUTE.ACCOUNTS,
            <UsergroupAddOutlined />
          ),
          // getItem(
          //   true,
          //   storageConstants.PAGES.MENU.SETTINGS,
          //   storageConstants.PAGES.ROUTE.SETTINGS,
          //   <SettingOutlined />
          // ),
        ]}
      />
    </Sider>
  );
};

export default SideMenu;
